import { DestroyRef, Directive, ElementRef, inject, Input } from "@angular/core";
import { AppSessionService } from "@vadmin/account/auth";
import { differenceInCalendarDays } from "date-fns";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { TenantInfo } from "@api/core.models";
import { AppConsts } from "../helpers/AppConsts";

@Directive({
    selector: "[appDisabledWhenExpired]",
    standalone: true,
})
export class DisabledWhenExpiredDirective {
    private el = inject(ElementRef<HTMLElement>);
    private appSession = inject(AppSessionService);
    private destroyRef = inject(DestroyRef);

    private inputEnabled = true;
    private expired = false;

    @Input()
    set appDisabledWhenExpired(value: boolean | "" | undefined) {
        this.inputEnabled = value !== false;
        this.apply();
    }

    constructor() {
        this.appSession.onTenantInfoChanged.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((val: TenantInfo) => {
            if (abp.setting.get(AppConsts.Settings.ApplicationVersion) === "2.0") {
                this.expired = this.appSession.isLockedV2();
            } else {
                const checkDebt = abp.setting.getBoolean("System.Payments.EnableDebtLock");
                this.expired = checkDebt && !!val?.subscriptionInfo?.activeBilling
                    && Object.values(val.subscriptionInfo.activeBilling).some((billing) => {
                        const days = differenceInCalendarDays(billing, new Date());
                        return days <= -30;
                    });
            }

            this.apply();
        });
    }

    private apply(): void {
        const disabled = this.inputEnabled && this.expired;
        this.el.nativeElement.classList.toggle("plan-expired", disabled);
        this.el.nativeElement.toggleAttribute("aria-disabled", disabled);
    }
}
